window.mobileReg = /^1[34578]\d{9}$/   //手机号正则
window.idReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/             //身份证号正则
window.pwReg = /^(?![^a-zA-Z]+$)(?!\D+$).{6,20}$/    //6-20位字母和数字组合，字符不限
window.codeReg = /[0-9]\d{5}/   //验证码正则
window.imgcodeReg = /[A-Za-z0-9\u4e00-\u9fa5]{1,10}/   //验证码正则
window.bankReg = /^([1-9]{1})(\d{15}|\d{18})$/   //银行卡号正则
window.moneyReg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/ //购买金额
window.dateReg = /^\d{4}(\/)\d{1,2}\1\d{1,2}$/ //时间正则 YYYY/MM/DD
window.accountReg = /^\d{11,18}$/  //大于11小于18位数字
window.emailReg = /^([a-zA-Z0-9_-]{1,16})@([a-zA-Z0-9]{1,9})(\.[a-zA-Z0-9]{1,9}){0,3}(\.(?:com|net|org|edu|gov|mil|cn|us)){1,4}$/  //邮箱

window.regs = {
    account: {
        reg: accountReg,
        msg: '请输入正确的身份证号/手机号'
    },
    password: {
        reg: pwReg,
        msg: '请输入正确的密码'
    },
    imgcode: {
        reg: imgcodeReg,
        msg: '请输入正确的图片验证码'
    },
    mobile: {
        reg: mobileReg,
        msg: '请输入正确的手机号码'
    },
    code: {
        reg: codeReg,
        msg: '请输入正确的验证码'
    },
    bank_account: {
        reg: bankReg,
        msg: '请输入正确的银行卡号'
    },
    id_no: {
        reg: idReg,
        msg: '请输入正确的身份证号'
    },
    email: {
        reg: emailReg,
        msg: '请输入正确的邮箱地址'
    }
}

window.doValidate = function(form){
	var validateType=$(form).hasClass('form1');
    var items = $(form).find('.form-item')
    var result = true
    $.each(items, function(i, v){
        var ipt = $(v).find('input')
        var value = ipt.val()
        var item = $(v)
        var vReg = regs[ipt.data('validate')]
        ipt.on('blur', function(){
            if($(this).val() == ''){
            	ipt.addClass('error');
            	if (validateType) {
            		ipt.next('.error-msg-box').removeClass('error-msg-show');
            	} else{
            		$(this).next('.error-notice').fadeOut();
            	}
            }else if(vReg && !vReg.reg.test($(this).val()) && $(this).val() != ''){
            	ipt.removeClass('error');
                if (validateType) {
            		ipt.next('.error-msg-box').addClass('error-msg-show').html(vReg.msg);
            	} else{
            		$(this).next('.error-notice').fadeIn().html(vReg.msg);
            	}
            }else{
            	ipt.removeClass('error');
                if (validateType) {
            		ipt.next('.error-msg-box').removeClass('error-msg-show');
            	} else{
            		$(this).next('.error-notice').fadeOut();
            	}
            }
        });

        if(value == ''){
        	ipt.addClass('error');
            if (validateType) {
            	ipt.next('.error-msg-box').addClass('error-msg-show').html(ipt.attr('placeholder'))
            } else{
            	ipt.next('.error-notice').show().html(ipt.attr('placeholder'));
            }
            result = false
            return false
        }else if(vReg && !vReg.reg.test(value) && value != '' && !ipt.hasClass('password-user')){
        	ipt.removeClass('error');
             if (validateType) {
                ipt.next('.error-msg-box').addClass('error-msg-show').html(vReg.msg);
            } else{
            		ipt.next('.error-notice').fadeIn().html(vReg.msg);
            }
            result = false
            return false
        }else{
        	 ipt.removeClass('error');
             if (validateType) {
                ipt.next('.error-msg-box').removeClass('error-msg-show');
            	} else{
            		ipt.next('.error-notice').fadeOut();
            	}
            result = true
        }

    })
    return result
}



// WEBPACK FOOTER //
// ./src/js/validate.js